/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { useMemo } from 'react';
import { COMMAND_PALETTE_SECTIONS } from '@jira/compal__common/src/common/constants.tsx';
import { COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY } from '@jira/compal__common/src/constants.tsx';
import { useCommandKeywords } from '@jira/compal__common/src/controllers/use-command-keywords/index.tsx';
import { COMMAND_PALETTE_REGISTRY_IDS } from '@jira/compal__registry/src/common/constants/registry/index.tsx';
import { useRegisterCommands } from '@jira/compal__registry/src/controllers/use-register-commands/index.tsx';
import {
	type Command,
	CommandActionType,
} from '@jira/compal__command-palette/src/common/types/commands/index.tsx';
import NotificationDirectIcon from '@atlaskit/icon/core/notification';
import { useIntl, defineMessage } from '@atlassian/jira-intl';
import { CHECK_NOTIFICATIONS_COMMAND_ID } from './constants.tsx';

const checkNotifications = defineMessage({
	id: 'atlassian-navigation.notifications.command-palette.check-notifications',

	defaultMessage: 'Check notifications',
	description: 'Command name in the command palette to open notifications dropdown',
});

export const useRegisterNotificationsInCommandPalette = (onClick: () => void): void => {
	const { formatMessage } = useIntl();
	const { getKeywords } = useCommandKeywords();

	const commands: Command[] = useMemo(
		() => [
			{
				id: CHECK_NOTIFICATIONS_COMMAND_ID,
				name: formatMessage(checkNotifications),
				primaryAction: {
					type: CommandActionType.PERFORM,
					perform: onClick,
				},
				keywords: getKeywords('checkNotificationsSynonyms'),
				section: COMMAND_PALETTE_SECTIONS.quickActions,
				priority: COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY.checkNotifications,
				components: {
					LeftIcon: () => <NotificationDirectIcon spacing="spacious" label="" aria-hidden />,
				},
				analytics: {
					action: 'checkNotifications',
				},
			},
		],
		[formatMessage, getKeywords, onClick],
	);

	useRegisterCommands(COMMAND_PALETTE_REGISTRY_IDS.CHECK_NOTIFICATIONS, commands);
};
